import React from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';
import MLModalService from './MLModalService';

function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

/*
 * Used to inject MLModalService as prop to the wrapped component, specially useful in class components.
 * The prop will be called 'modalService'.
 */
export function withMLModalService(WrappedComponent) {
    function WithMLModalService(props) {
        const ModalService = MLModalService()


        return (
            <WrappedComponent
                {...props}
                modalService={ModalService}
            />
        );
    }
    hoistNonReactStatic(WithMLModalService, WrappedComponent);
    WithMLModalService.displayName = `WithMLModalService(${getDisplayName(WrappedComponent)})`;
    return WithMLModalService;
}